import {handleActions} from "redux-actions"
import {SET_PORTS} from "../actionTypes/portsListActions"
var update = require('immutability-helper')

const initialState=[]

const reducer=handleActions({
  [SET_PORTS]:(state,action)=>update(state,{$set:action.payload})
},initialState)

export default reducer
